import { getRandomCoordinates } from './coords';
import { finalizeWordPlacement } from './finalize';
import { canInsertVertical } from './validate';

export function insertVertical(engine, word, direction, game, attempts = 0) {
  const { rows, columns } = engine.model;

  if (attempts > engine.maxInsertAttempts) {
    engine.state.registerFailure(word, direction);
    engine.state.addUnplaced(word);
    return false;
  }

  const { row, col } = getRandomCoordinates(rows, columns);

  if (!canInsertVertical(engine, word, row, col, game.table)) {
    return insertVertical(engine, word, direction, game, attempts + 1);
  }

  for (let i = 0; i < word.length; i += 1) {
    const idx = (row + i) * columns + col;
    game.table[idx].text = word[i];
  }

  finalizeWordPlacement(engine, game, word, row, col, direction);
  return true;
}
